import React, { useEffect, useState } from 'react';
import { getVisitorId } from '../utils/utils';
import getUserAttributes from '../utils/getUserAttributes';
import { OptimizelyProvider } from '@optimizely/react-sdk';
import { shape, object, bool, node, string } from 'prop-types';

const propTypes = {
    optimizely: shape({
        initialConfig: shape({
            datafile: object
        })
    }),
    isServerSide: bool.isRequired,
    children: node.isRequired,
    pageGroup: string.isRequired,
    nativeapp: string,
    additionalUserAttrs: object
};

const Provider = props => {
    const { optimizely, isServerSide, children, pageGroup, nativeapp, additionalUserAttrs = {} } = props;

    const [isGaPresent, setIsGaPresent] = useState(undefined);
    const [userSummary, setUserSummary] = useState({});

    useEffect(() => {
        document.addEventListener('readystatechange', () => {
            if (document.readyState === 'complete') {
                setIsGaPresent(typeof window.ga === 'function' && window.GoogleAnalyticsObject === 'ga');
            }
        });
        (async () => {
            const userSummary = await window?.SF?.getUserSummary();
            setUserSummary(userSummary);
        })();
        return () => {
            // this gets called when the component unmounts
        };
    }, []);

    const initialUserAttributes =
        typeof window !== 'undefined'
            ? optimizely?.user?.attributes && Object.keys(optimizely.user.attributes).length > 0
                ? { ...optimizely.user.attributes }
                : getUserAttributes({}, pageGroup, nativeapp, additionalUserAttrs)
            : { ...additionalUserAttrs };

    const visitorId = getVisitorId();

    useEffect(() => {
        if (userSummary && optimizely && isGaPresent !== undefined) {
            optimizely.setUser({
                id: optimizely.user.id,
                attributes: {
                    ...optimizely.user.attributes,
                    ...getUserAttributes(userSummary, pageGroup, nativeapp, additionalUserAttrs),
                    ga_present: isGaPresent
                }
            });
        }
    }, [isGaPresent, optimizely, userSummary]);

    useEffect(() => {
        if (pageGroup) {
            optimizely?.setUser?.({
                id: optimizely.user?.id,
                attributes: {
                    ...optimizely.user?.attributes,
                    view_name: pageGroup
                }
            });
        }
    }, [pageGroup]);

    return optimizely?.initialConfig?.datafile ? (
        <OptimizelyProvider optimizely={optimizely} user={{ id: visitorId, attributes: initialUserAttributes }} isServerSide={isServerSide}>
            {children}
        </OptimizelyProvider>
    ) : (
        <>{children}</>
    );
};

Provider.propTypes = propTypes;

export default Provider;
